<template>
  <v-container fluid class="pa-0">
    <v-card class="mb-4" v-if="updatedGameParams != null">
      <v-toolbar card color="primary" dark dense>
        <v-spacer></v-spacer>
        <v-toolbar-title >{{$t('gameVersions.params')}}</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-form ref="updateForm">
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap >
              <v-flex xs12>
                <v-switch
                  class="mt-0 mb-2"
                  hide-details
                  :label="$t('gameVersions.skipInstructions')"
                  v-model="updatedGameParams.skipInstructions"
                ></v-switch>
              </v-flex>
              <v-flex xs12>
                <v-switch
                  class="mt-0 mb-2"
                  hide-details
                  :label="$t('gameVersions.timerActivated')"
                  v-model="updatedGameParams.dayTimer"
                ></v-switch>
              </v-flex>
              <v-flex xs12 v-if="updatedGameParams.dayTimer">
                <v-text-field
                  :label="$t('gameVersions.timerCount')"
                  type="number"
                  v-model.number="updatedGameParams.dayTimerCount"
                  :rules="[v => !!v || $t('fields.required')]"
                  :hint="$t('gameVersions.timerCountHint')"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  :append-icon="$i18n.locale === 'en' ? 'attach_money' : 'euro_symbol'"
                  :label="$t('gameVersions.storageCost')"
                  type="number"
                  v-model.number="updatedGameParams.storageCost"
                  :rules="[v => !!v || $t('fields.required')]"
                  hint
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  :append-icon="$i18n.locale === 'en' ? 'attach_money' : 'euro_symbol'"
                  :label="$t('gameVersions.delayCost')"
                  type="number"
                  v-model.number="updatedGameParams.delayCost"
                  :rules="[v => !!v || $t('fields.required')]"
                  hint
                ></v-text-field>
              </v-flex>
              <v-flex xs12 v-if="currentGame.gameVersion.dd">
                <v-text-field
                  :label="$t('gameVersions.weekNbrAutoCmj')"
                  type="number"
                  v-model.number="updatedGameParams.weekNbrAutoCmj"
                  :rules="[v => !!v || $t('fields.required')]"
                  hint
                ></v-text-field>
              </v-flex>
              <v-flex xs12 v-if="currentGame.gameVersion.dd">
                <v-text-field
                  :label="$t('gameVersions.changeBufferEveryNbrWeek')"
                  type="number"
                  v-model.number="updatedGameParams.changeBufferEveryNbrWeek"
                  :rules="[v => !!v || $t('fields.required')]"
                  hint
                ></v-text-field>
              </v-flex>
              <v-flex xs12 v-if="currentGame.gameVersion.dd">
                <v-select
                  :items="$store.getters['gameVersions/flowEquationDisplayModes']"
                  :label="$t('gameVersions.flowEquationDisplayModes.title')"
                  item-text="name"
                  item-value="number"
                  v-model="updatedGameParams.flowEquationDisplay"
                ></v-select>
              </v-flex>
              <v-flex xs12 v-if="currentGame.gameVersion.dd">
                <v-switch
                  class="mt-0 mb-2"
                  hide-details
                  :label="$t('gameVersions.ddOrderPreFilled')"
                  v-model="updatedGameParams.ddOrderPreFilled"
                ></v-switch>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            :loading="$store.state.gameVersions.loading"
            submit
            flat
            @click.native="update"
          >{{$t('general.update')}}</v-btn>
          <v-btn
            color="secondary"
            :disabled="$store.state.gameVersions.loading"
            submit
            flat
            @click.native="initData"
          >{{$t('general.cancel')}}</v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {

  name: "InGameParams",

  components: {},

  data() {
    return {
      updatedGameParams: null
    };
  },

  mounted() {
    this.initData()
  },

  methods: {
    initData () {
      this.updatedGameParams = Object.assign({}, this.currentGame.params)
    },

    async update() {
      if (this.$refs.updateForm.validate()) {
        await this.updateGame({
          id: this.currentGame._id,
          data: {
            params: this.updatedGameParams
          }
        })
      }
    },

    ...mapActions('games', {
      updateGame: 'update'
    })

  },
  
  computed: {
    ...mapGetters('games', {
      currentGame: 'current'
    })
  }
};
</script>
